import * as PourOver from 'pourover';

import { FilterBase } from './FilterBase';

export class LockFilter extends FilterBase {
  makeIndex(): any {
    return new PourOver.makeExactFilter('lockedAllocation', [true, false]);
  }

  getMatchSet(collection: any, filterSettings): any {
    if (filterSettings.showLocked) {
      return collection.filters.lockedAllocation.getFn(true);
    } else if (filterSettings.showUnlocked) {
      return collection.filters.lockedAllocation.getFn(false);
    }
  }

  getCounts(): any {
    return {
      locked: 0,
      unlocked: 0
    };
  }
}
